/* **************************************************** Finishing Shedule Accessory Sub Name */
export interface FSAccessorySub {
    id: number;
    accessory_name_id: number;
    accessory_sub_name: string;
    created_by: number | null;
}

export const mapFSAccessorySub = (data: any): FSAccessorySub => {
    if (!data) {
        throw new Error("Invalid Data");
    }

    const res: FSAccessorySub = {
        id: data.id,
        accessory_name_id: data.accessory_name_id,
        accessory_sub_name: data.accessory_sub_name,
        created_by: data.created_by || null,
    };

    return res;
};

export const mapFSAccessorySubs = (data: any[]): FSAccessorySub[] => {
    if (!Array.isArray(data)) {
        throw new Error("Invalid Data");
    }

    return data.map(mapFSAccessorySub);
};
